import { Component } from '@angular/core';
import * as fromRoot from '../reducers';
import { Store } from '@ngrx/store';
import { ListItem } from '../../core/models/list-item';
import { Observable } from 'rxjs/Observable';
import { SearchCriteria } from '../models/search-criteria';
import * as actions from '../actions/search';
import * as fromApp from '../../../app.reducer';
@Component({
  selector: 'app-advanced-search',
  template: `
  <p>
    To view specific Superfund documents, narrow your selection from the following criteria.
    Where applicable, hold the "CTRL" key to select multiple items.
  </p>
  <p>
    <irar-advanced-search-form [sites]="sites$ | async"
      [farms]="farms$ | async"
      [authors]="authors$ | async"
      [loggedIn]="loggedIn$ | async"
      [searching]="searching$ | async"
      (search)="searchDocuments($event)"></irar-advanced-search-form>
  </p>
  `
})
export class AdvancedSearchContainerComponent {
  sites$: Observable<ListItem[]>;
  farms$: Observable<ListItem[]>;
  searching$: Observable<boolean>;
  authors$: Observable<string[]>;
  loggedIn$: Observable<boolean>;

  constructor(private store: Store<fromRoot.State>,
    private rootStore: Store<fromApp.State>) {
    this.farms$ = this.store.select(fromRoot.getFarms);
    this.sites$ = this.store.select(fromRoot.getSites);
    this.searching$ = this.store.select(fromRoot.getSearchLoading);
    this.authors$ = this.store.select(fromRoot.getAuthors);
    this.loggedIn$ = this.rootStore.select(fromApp.getAuthIsAdmin);
  }

  searchDocuments(e: SearchCriteria) {
    this.store.dispatch(new actions.SearchDocumentsAction(e));
  }
 }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/containers/advanced-search.ts